<template>
  <div class="page-container">
    <div class="pre-wrap page-container-content fr-view" v-html="content"></div>
  </div>
</template>

<script>
export default {
  props: ["content"]
};
</script>

<style lang="scss">
@import "~froala-editor/css/froala_style.min.css";
.page {
  &-container {
    max-width: 800px;

    &-content {
      font-size: 1.2rem;
    }
    img {
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }
  }
}
</style>
